import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  id: '',
  key: '',
  name: '',
  description: '',
};

const securityManagementSlice = createSlice({
  name: 'securityManagement',
  initialState,
  reducers: {
    resetSecurityState: (state) => {
      Object.assign(state, initialState);
    },
    setPatient(state, action) {
        const { id, fullName } = action.payload;
        state.id = id;
        state.name = fullName;
    },
    setSecurityItem(state, action) {
        const { id, value } = action.payload;
        state[id] = value;
    },
  },
});

export const {
    resetSecurityState,
    setPatient,
    setSecurityItem
} = securityManagementSlice.actions;

export default securityManagementSlice.reducer;
